import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const WorkOrderTypes = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        İş Emri Türleri
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>İş emri türleri yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default WorkOrderTypes;
